package com.rosario.juridico.platform

import androidx.compose.runtime.Composable
import kotlinx.browser.window

actual object ShareManager {
    @Composable
    actual fun register() {
        // No action needed for JS
    }

    actual fun shareText(text: String) {
        val navigator = window.navigator
        // Intentar usar Web Share API si está disponible (HTTPS necesario)
        if (navigator.asDynamic().share != null) {
            navigator.asDynamic().share(object {
                val text = text
            })
        } else {
            // Fallback: Copiar al portapapeles y avisar
            window.navigator.clipboard.writeText(text)
            window.alert("Texto copiado al portapapeles para compartir.")
        }
    }
}
